export default {"src":"/_next/static/media/FRO.6efa7f15.svg","height":18,"width":18};